<template>
    <vx-page-layout layout="sidebar">
        <template v-slot:sidebar>
            <settings-sidebar></settings-sidebar>
        </template>
        <div ref="content">
            <div class="max-w-(--breakpoint-lg)">
                <page-header>
                    Voxie Relay
                    <template v-slot:subtitle> Integration Platform </template>
                </page-header>

                <vx-box-glass class="text-slate-700 font-sans">
                    <vx-wallpaper :icon="faCircleNodes"></vx-wallpaper>
                    <div class="relative p-6 xl:p-10 max-w-2xl">
                        <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                            Browse Voxie Relay integrations that connect third-party services with Voxie. By leveraging
                            these integrations, you can automate workflows, synchronize data, and enhance the overall
                            functionality of your Voxie experience.
                        </p>
                    </div>
                </vx-box-glass>

                <div class="mt-4 lg:mt-6 grid md:grid-cols-1 lg:grid-cols-3 gap-6">
                    <relay-integration-tile
                        v-for="integration in activeIntegrations"
                        :key="integration.slug"
                        :integration="integration"
                    />
                </div>

                <div class="mt-8 border-t border-slate-200 pt-8">
                    <span class="font-bold text-xl">Coming Soon</span>
                    <div class="mt-4 grid md:grid-cols-1 lg:grid-cols-3 gap-6">
                        <relay-integration-tile
                            v-for="integration in comingSoonIntegrations"
                            :key="integration.slug"
                            :integration="integration"
                        />
                    </div>
                </div>
            </div>
        </div>
    </vx-page-layout>
</template>

<script setup lang="ts">
import PageHeader from '~/components/general/PageHeader.vue';
import SettingsSidebar from '~/components/settings/menus/SettingsSidebar.vue';
import RelayIntegrationTile from './RelayIntegrationTile.vue';
import { integrations } from './integrations';
import { faCircleNodes } from '@fortawesome/pro-regular-svg-icons';
import { VxBoxGlass, VxPageLayout, VxWallpaper } from '@voxie/frontend-components';
import { computed } from 'vue';

const activeIntegrations = computed(() => integrations.filter((i) => !i.comingSoon));
const comingSoonIntegrations = computed(() => integrations.filter((i) => i.comingSoon));
</script>
